import { Component, OnInit } from "@angular/core";
import { HomeNavigationService } from "navigation/list/home.navigation.service";

@Component({
	templateUrl: "./noprocess.component.html",
	styleUrls: ["./noprocess.component.scss"],
})
export class NoProcessComponent implements OnInit {
	constructor(private homeNavigationService: HomeNavigationService) {}

	ngOnInit(): void {
		this.homeNavigationService.update();
	}
}
